import {LanguageSwitcherSectionSeparatorDefaultBox} from "./language-switcher-section-separator.default.box";

export const LanguageSwitcherSectionSeparatorBox = LanguageSwitcherSectionSeparatorDefaultBox;
